// adapter-specific-playbook-paths.ts
//
// Playbooks chosen by command ADAPTER rather than by ticket kind
// (`workflows/autopilot/<kind>.md`). Two adapters share a kind with another
// adapter but need their own instructions:
//   - `review-clean-v1` (C2, kind `review`): must NOT see `review.md`, which
//     carries the implementing session's framing;
//   - `testaudit-v1` (kind `test`): close-out A' 2026-09-30 — keyed by kind it
//     got `test.md` (or nothing), so `testaudit.md` (read-only limit, 5 steps,
//     report path, `uncovered_areas`) never reached the worker.
import { join } from "node:path";

export const ADAPTER_PLAYBOOK_RELATIVE_PATHS: Readonly<Record<string, string>> = {
  "review-clean-v1": join("workflows", "autopilot", "review-clean.md"),
  "testaudit-v1": join("workflows", "autopilot", "testaudit.md"),
};

/** Default playbook: by ticket kind. */
export function kindPlaybookRelativePath(kind: string): string {
  return join("workflows", "autopilot", `${kind}.md`);
}
